import i18n from "../../../language/i18n";
import { useNavigate } from "react-router-dom";
import { Icon } from "../../../library";
import ReportCardView from "../reports/ReportCardView";
import { reportStyles } from "./ReportStyles";

const Report = ({ dataTour }: { dataTour?: string }) => {
  const navigate = useNavigate();

  return (
    <div className="qck-root" data-tour={dataTour}>
      <style>{reportStyles}</style>
      <div className="qck-header">
        <div className="qck-title-group">
          <Icon name="report" size={20} />
          <p className="qck-title">{i18n.t("reports")}</p>
        </div>
        <div
          className="qck-see-all-wrapper"
          onClick={() => {
            navigate("/reports");
          }}
        >
          <p className="qck-see-all">{i18n.t("see_all")} →</p>
        </div>
      </div>
      <div className="qck-body no-scrollbar">
        <ReportCardView isMinimized={true} />
      </div>
    </div>
  );
};

export default Report;
